import axios from 'axios';
import { AxiosInstance } from 'axios';
import AuthService from '@/services/auth.service';

const AUTH_API: AxiosInstance = axios.create({
  baseURL: process.env.VUE_APP_FURTHER_AUTH_API,
  headers: {
    'x-api-key': process.env.VUE_APP_API_KEY,
  },
});

AUTH_API.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response.status === 401) {
      AuthService.signOutUser(false);
    }
    return Promise.reject(error.response.data);
  },
);

export default AUTH_API;
